var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"status-chip",attrs:{"small":"","color":_vm.color,"outlined":""}},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.text))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }